(function() {

	angular
		.module('ngmvac', [
			'ngAnimate',
			'slickCarousel',
			'ngSanitize',
			'rzModule',
			'angularUtils.directives.dirPagination',
			'duScroll',
			'angular.filter',
			'mvac.components',
            'ui.swiper'
			
		])
		.factory('httpInterceptor', ['$window', function($window) {

			return {
				request: Request
			};

			function Request (config) {
				if(config.url !== 'rzSliderTpl.html')
					config.url += "?ts=" +  Date.now();

				return config;
			}

		}])
		.config(Config); 

	Config.$inject = ['$httpProvider', 'paginationTemplateProvider', '$qProvider', '$compileProvider'];

	function Config($httpProvider, paginationTemplateProvider, $qProvider, $compileProvider) {
		$httpProvider.interceptors.push('httpInterceptor');
		paginationTemplateProvider.setPath('/tpl/dirPagination.tpl.html');
		$qProvider.errorOnUnhandledRejections(false);
		$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript:)/);
	}

})();
